// extracted by mini-css-extract-plugin
export var container = "_47-1";
export var cornerButtonContainer = "_47-5";
export var disabled = "_47-2";
export var fileContainer = "_47-4";
export var hiddenInput = "_47-3";
export var widthContainer = "_47-0";